export default __webpack_public_path__ + "static/media/Maxime Cherix.df4d6700.jpeg";